import { selectAuth } from "Store/auth/authSelectors";
import PubSub, { Message } from "Utils/pubSub";
import { selectElementsAddress } from "Views/elements/store/elementsSelectors";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectCart } from "../store/cartSelectors";

export const useStandaloneCart = ({ liquid }) => {
  const address = useSelector(selectElementsAddress);
  const auth = useSelector(selectAuth);
  const cart = useSelector(selectCart);

  useEffect(() => {
    const getProducts = async (params) => {
      try {
        const products = await liquid.product({
          ids: params.ids,
          latitude: params.latitude || address.latitude,
          longitude: params.longitude || address.longitude,
          shipState: params.shipState || address.state,
          shipAddress: params.shipAddress,
          top100: !auth.productionReady,
        });
        PubSub.publish(Message.GetProductSuccess, products);
      } catch (error) {
        console.error(error);
        PubSub.publish(Message.GetProductSuccess, error);
      }
    };

    const getCart = async () => {
      if (!cart?.id) return;

      try {
        const rawCart = await liquid.cart({ id: cart?.id });
        PubSub.publish(Message.CartGetSuccess, { cart: rawCart });
      } catch (error) {
        console.error(error);
        PubSub.publish(Message.CartGetSuccess, error);
      }
    };

    const updateCart = async ({ cart: cartUpdate }) => {
      if (!cart?.id) return;
      try {
        const rawCart = await liquid.cart({ ...cartUpdate, id: cart?.id });
        PubSub.publish(Message.CartUpdated, { cart: rawCart });
      } catch (error) {
        console.error(error);
        PubSub.publish(Message.GetProductSuccess, error);
      }
    };

    PubSub.subscribe(Message.CartGet, getCart);
    PubSub.subscribe(Message.CartUpdate, updateCart);
    PubSub.subscribe(Message.GetProduct, getProducts);

    return () => {
      PubSub.unsubscribe(Message.CartGet, getCart);
      PubSub.unsubscribe(Message.CartUpdate, updateCart);
      PubSub.unsubscribe(Message.GetProduct, getProducts);
    };
  }, [liquid, address.latitude, address.longitude, address.state, auth?.productionReady, cart?.id]);
};
